/**
 * 
 * @param {import("@/types/Product").Product} item 
 * @param {Object} categoriesSelected 
 * @returns 
 */
const isCategoryIncluded = (item, categoriesSelected) => {
        let categoryName = item.categoryName;
        if (!categoryName) {
            if (item.combo) categoryName = "Combos";
            else categoryName = "Productos";
        }
        const categoriesSelectedEntries = Object.entries(categoriesSelected);
        return (!categoriesSelectedEntries.some(([_,selected]) => selected)) || categoriesSelected[categoryName];
    };



/**
 *
 * @param {Array<import("@/types/Product").Product>} catalog 
 * @param {Object} categoriesSelected 
 * @param {string} filterProductInputValue 
 * @param {string} selectedLetter 
 * @returns {Array<import("@/types/Product").Product>}
 */
export const filterProducts = (catalog,categoriesSelected, filterProductInputValue, selectedLetter) => {
    return catalog?.filter(({ name = "", sku = "", tags = "", ...item }, ) => {
            const nameLower = name?.toLowerCase();
            const skuLower = sku?.toLowerCase();
            const tagsLower = tags?.toLowerCase();
            const filterValue = filterProductInputValue?.toLowerCase();
            const hasSelectedCategories = Object.keys(categoriesSelected).length > 0;
            const includesFilterValue =  filterValue ?
                (nameLower.includes(filterValue) || skuLower.includes(filterValue) || tagsLower.includes(filterValue))
                : true;

            const includesCategory = hasSelectedCategories ? isCategoryIncluded(item, categoriesSelected) : true;
            const includesLetter = !selectedLetter || (nameLower.trim()[0] === selectedLetter.toLowerCase());

            return includesFilterValue && includesCategory && includesLetter;
        }) || []
}